import isDate from "lodash-es/isDate";
import dayjs, { type ManipulateType } from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend( isSameOrAfter );

export function getExpiryDate ( itemDate: Date | string, daysUntilExpired = 7, unit: ManipulateType = "day" ) {
  let result = null;

  if ( isDate( itemDate ) ) {
    result = dayjs( itemDate ).add( daysUntilExpired, unit );
  }
  return result;
}

export function isDateEqualToCurrent  ( date: Date | string,  unit: ManipulateType ) {
  let result = false;

  if ( isDate( date ) ) {
    switch ( unit?.toLowerCase() ) {
      case "d":
      case "day":
      case "m":
      case "month":
      case "y":
      case "year":
        result = dayjs().isSame( date, unit );
        break;
      default:
        console.warn( `${unit} is not a valid unit. Unit parameter should be a string of either, 'day', 'd', 'month', 'm', 'year' or 'y'.` );
    }
  }
  return result;
}

export function isArticleNewlyListed ( publishedDate: Date | string, includeExpiry = false ) {
  let result = false;

  if ( isDate( publishedDate ) ) {
    const expiryDate = getExpiryDate( publishedDate );
    const hasExpired = !dayjs().isSameOrAfter( expiryDate );

    result = isDateEqualToCurrent( publishedDate, "month" )
      || ( includeExpiry && !hasExpired );
  }

  return result;
}
